import axios from "axios";
import authHeader from '../../../authheader'

const PERENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualPeRenewal";

const getViolation = (renewalId) => {
    return axios.get(`${PERENEWALURL}/violation`, { headers: authHeader(), params: { renewalId } });
}
const postViolation = (data) => {
    return axios.post(`${PERENEWALURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}